import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCreditSettlementFilter } from "redux/settlement-credit/creditPayment";
import { addEditDataAPI } from "services/CRUDServices";

export const usePayment=()=>{
  const [loading, setLoading] = useState(false);
  const [refId, setRefId] = useState();
  const dispatch=useDispatch()
   const { filter } = useSelector(
     (state: any) => state.creditSettlement
   );
   async function handleSubmit(item) {
    try {
      const body = {

        // invoiceNumber: item.id,
        invoiceNumber:Date.now(),
        callBackUrl: `${process.env.REACT_APP_AUTHORITY}/public/mellat-payment-success-hub`,
        // amount:getTotalAmount(),
        amount: item.pay,
      };
      // setLoading(true);
      addEditDataAPI("/customer-api/payment/mellat/hub/provide-bank-ref-hub","post",body).then(res=>{
           setLoading(false)
           let ref = res.data.result.split(',');
           setRefId(ref[1]);
           localStorage.setItem("creditId",item.id)
           dispatch(setCreditSettlementFilter(filter))
      })

    } catch {
      setLoading(false);
    }
  }

    return {loading,refId,handleSubmit}    
}
